<template>
  <TsCard append-class="rounded-full shadow-none border-none px-4 py-2" :data-testid="baseDataTestId + 'section'">
    <TsMedia append-class="items-center" :data-testid="baseDataTestId + 'content'">
      <TsMediaStart append-class="mr-2">
        <TsImage height="64" width="64" :src="props.image" alt="light-image" :data-testid="baseDataTestId + 'rounded-image'" loading="lazy"/>
      </TsMediaStart>
      <TsMediaContent>
        <TsTypography as="h3" :data-testid="baseDataTestId + 'heading'">{{ props.heading }}</TsTypography>
        <TsTypography append-class="leading-5" :data-testid="baseDataTestId + 'description'">{{ props.description }}</TsTypography>
      </TsMediaContent>
    </TsMedia>
  </TsCard>
</template>

<script setup lang="ts">

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

type Props = {
  alt?: string,
  image?: string,
  description?: string,
  heading: string;
};

const props = withDefaults(defineProps<Props>(), {
  image: '/images/durability.svg',
  heading: 'Durability',
  description: 'Built to withstand heavy use, ensuring long-lasting performance.',
});

const baseDataTestId = "card-rounded-v1-";

</script>